<template>
    <div>
        <!-- Postcode -->
        <postcode-lookup-field
            class="contentsquare_sensitive_data"
            ref="postcode"
            address-type="billing"
            v-model="address.postcode"
            :mandatory="true"
            @address-selected="updateSelectedAddress"/>

        <!-- Address line 1 -->
        <div>
            <input-field
                class="mb-3 contentsquare_sensitive_data"
                id="billing_address_line_1"
                v-model="address.addressLine1"
                :mandatory="true"
                :is-valid="!errorHandler.has('billing_address_line_1')"
                :message="errorHandler.get('billing_address_line_1')"
                :label="$t('BILLING_ADDRESS_FORM_FIRST_LINE')"/>
        </div>

        <!-- Address line 2 -->
        <div>
            <input-field
                class="mb-3 contentsquare_sensitive_data"
                v-model="address.addressLine2"
                :label="$t('BILLING_ADDRESS_FORM_SECOND_LINE')"/>
        </div>

        <!-- City -->
        <div>
            <input-field
                class="mb-3 contentsquare_sensitive_data"
                id="billing_address_city"
                v-model="address.city"
                :mandatory="true"
                :is-valid="!errorHandler.has('billing_address_city')"
                :message="errorHandler.get('billing_address_city')"
                :label="$t('BILLING_ADDRESS_FORM_TOWN')"/>
        </div>

        <!-- Countries address dropdown -->
        <div class="input">
            <label class="input__label"
                   v-text="$t('BILLING_ADDRESS_FORM_COUNTRY')"></label>
            <multiselect
                v-model="selectedCountry"
                track-by="iso"
                label="name"
                placeholder="Please select country"
                openDirection="below"
                :mandatory="true"
                :allow-empty="false"
                :options="countries"/>
            <p class="message"
               v-text="errorHandler.get('billing_address_country')"/>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import CountryService from '@/services/logistics/CountryService';
import InputField from '@/components/forms/fields/InputField';
import PostcodeLookupField from '@/components/forms/fields/PostcodeLookupField';

export default {
    name: 'BillingAddressForm',
    data: () => {
        return {
            address: {
                addressLine1: null,
                addressLine2: null,
                city: null,
                postcode: null,
                country: null,
            },
            selectedCountry: null,
        };
    },
    props: {
        value: {
            required: true,
            type: Object,
        },
        errorHandler: {
            required: false,
            default: () => new ErrorResponseHandler(),
            validator: function(value) {
                return value instanceof ErrorResponseHandler;
            },
        },
    },
    mounted() {
        this.selectedCountry = this.countries.filter(item => item.iso === process.env.VUE_APP_COUNTRY_ISO);
    },
    methods: {
        updateSelectedAddress(address) {
            this.address.addressLine1 = address.addressline1;
            this.address.addressLine2 = address.posttown;
            this.address.city = address.country;
        },
    },
    computed: {
        countries() {
            return CountryService.getCountries()
                .map((country) => {
                    return {
                        name: country.name,
                        iso: country.iso,
                    };
                });
        },
    },
    watch: {
        address: {
            deep: true,
            handler(address) {
                this.$emit('input', address);
            },
        },
        value: {
            immediate: true,
            handler(value) {
                this.address.addressLine1 = value.addressLine1;
                this.address.addressLine2 = value.addressLine2;
                this.address.postcode = value.postcode;
                this.address.city = value.city;
                this.address.country = value.country;
            },
        },
    },
    selectedCountry: {
        handler(country) {
            this.address.country = country;
        },
        immediate: true,
    },
    components: {
        InputField,
        PostcodeLookupField,
        Multiselect,
    },
};
</script>
